import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import DatePicker from "react-datepicker";
import Select from 'react-select'
import {getKol} from "../../inc/Utils";
import moment from "moment-timezone";

export default function AdsNamingSetNameCreateSpecial() {
    const roles = new Role();
    let userId = roles.loginUserId;
    let typeId = Utils.ADSNAMING_GROUP_SPECIAL;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState('');
    let [lang, setLanguage] = React.useState('');
    let [projectType, setProjectType] = React.useState('');
    let [adsNaming, setAdsNaming] = React.useState('');

    let [adsNamingSetNameTypeId, setAdsNamingSetNameTypeId] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);

    let [example, setExample] = React.useState('');
    let [kolPage, setKolPage] = React.useState('');
    let [preview, setPreview] = React.useState('');
    let [platform, setPlatform] = React.useState('');
    let [platformId, setPlatformId] = React.useState(null);

    let [isCustomUrl, setIsCustomUrl] = React.useState(false);
    let [slugDisabled, setSlugDisabled] = React.useState(true);

    let [specialFilterId, setSpecialFilterId] = React.useState(null);
    let [specialFilter, setSpecialFilter] = React.useState('');
    let [zoneStatus, setZoneStatus] = React.useState(null);
    let [zoneStatusId, setZoneStatusId] = React.useState('');
    let [eventDate, setEventDate] = React.useState('');

    let [bgZoneId, setBgZoneId] = React.useState(null);
    let [bgZone, setBgZone] = React.useState('');
    let [bgZonePlaceholder, setBgZonePlaceholder] = React.useState('Select...');

    let [combineZoneId, setCombineZoneId] = React.useState(null);
    let [combineZone, setCombineZone] = React.useState('');
    let [combineZonePlaceholder, setCombineZonePlaceholder] = React.useState('Select...');

    let [eventReminderId, setEventReminderId] = React.useState(null);
    let [eventReminder, setEventReminder] = React.useState('');
    let [eventReminderPlaceholder, setEventReminderPlaceholder] = React.useState('Select...');

    let [staticPageId, setStaticPageId] = React.useState(null);
    let [staticPage, setStaticPage] = React.useState('');
    let [staticPagePlaceholder, setStaticPagePlaceholder] = React.useState('Select...');

    const navigate = useNavigate();

    React.useEffect(() => {
        (async function() {
            try {
                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);
                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);
                const resFilter = await Utils.getAdsNamingSpecialFilter();
                setSpecialFilter(resFilter);
                const resZoneStatus = await Utils.getAdsNamingZoneStatus();
                setZoneStatus(resZoneStatus);
                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);
                const resSetNameType = await Utils.getAdsNamingSetNameType();
                setAdsNamingSetNameType(resSetNameType);
                const resAdsNaming = await getAdsNaming();

                if(resAdsNaming.length > 0) {

                    let ex = [];
                    let ex2 = [];
                    let newAdsNaming = [];
                    if(resAdsNaming) {
                        newAdsNaming = resAdsNaming.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION);
                        let xLen = newAdsNaming.length;
                        if(xLen > 1) {
                            for(let i=0;i<2;i++) {
                                ex.push('{' + newAdsNaming[i].name + '}');
                            }
                        }
                        if(xLen > 2) {
                            for(let j=2;j<xLen;j++) {
                                ex2.push('{' + newAdsNaming[j].name + '}');
                            }
                        }
                    }
                    setAdsNaming(newAdsNaming);
                    setExample(ex.join('_') + '|' + ex2.join('_') + '_{Platform}|{Type}_[ST]');

                    let newKolPageId = [];
                    for(let rs of resAdsNaming) {
                        if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                            const resKolPage = await getKol();
                            if(resKolPage) {
                                let kolPageIds = [];
                                for(let row of resKolPage) {
                                    let id = row.id;
                                    kolPageIds.push({
                                        id: id + ':KOL' + rs.id,
                                        name:  row.name
                                    });
                                }
                                newKolPageId.push({
                                    id: rs.id,
                                    data: kolPageIds
                                });
                            }
                        }
                    }
                    setKolPage(newKolPageId);
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getAdsNaming() {
        const response = await fetch(Config.url.API_URL +'/api/adsNaming/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                typeId: Utils.ADSNAMING_TYPE_SETNAME
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = async () => {

        let param = await getParams();

        if(!isCustomUrl && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!isCustomUrl && !specialFilterId) {
            toast.error("กรุณาระบุ Filter Type");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !projectTypeId) {
            toast.error("กรุณาระบุ Zone Project");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !bgZoneId) {
            toast.error("กรุณาระบุ BG Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !combineZoneId) {
            toast.error("กรุณาระบุ Combine Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventDate) {
            toast.error("กรุณาระบุ Event Date");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventReminderId) {
            toast.error("กรุณาระบุ Event Reminder");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE && !staticPageId) {
            toast.error("กรุณาระบุ Static Page");
        }
        else if(!param.success) {
            toast.error("กรุณาเลือก Parameters ให้ครบถ้วน");
        }
        else if(!adsNamingSetNameTypeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(param.params.length <=0 || param.params.length >= 200) {
            toast.error("ขนาดตัวอักษรต้องไม่เกิน 200");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                specialFilterId: specialFilterId ? specialFilterId.id:null,
                                zoneStatus: zoneStatusId ? zoneStatusId.id:null,
                                eventDate: eventDate ? new Date(eventDate) : null,
                                webPage: null,
                                adsPlatformId: platformId ? platformId.id:null,
                                isCustomUrl: isCustomUrl ? 1:null,
                                lang: langId ? langId.id : null,
                                typeId: typeId,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectCode: null,
                                campaignDate: null,
                                adsNamingSetNameTypeId: adsNamingSetNameTypeId ? adsNamingSetNameTypeId.id : null,
                                params: param.params,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                sourceTypeIds: param.data
                            };

                            fetch(Config.url.API_URL +'/api/adsNamingSetName/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNamingSetName', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = async (obj) => {
        setLanguageId(obj);
        setSpecialFilterId(null);
        setProjectTypeId(null);
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        setStaticPageId(null);
        setEventDate('');
    };

    const onChangeFilterTypeId = async (obj) => {
        setSpecialFilterId(obj);
        if(obj?.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE) {
            setStaticPagePlaceholder('กำลังโหลด...');
            const resEv = await Utils.getStaticPage({langId: langId.id});
            setStaticPagePlaceholder('เลือก..');
            if(resEv && resEv.data && resEv.data) {
                setStaticPage(resEv.data);
            }
            else {
                toast.error('ไม่พบข้อมูล Static Page');
            }
        }
    };

    const onChangeProjectTypeId = async (obj) => {
        setProjectTypeId(obj);
        setBgZone('');
        if(obj && obj.id && zoneStatusId) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: obj.id, zoneStatusId: zoneStatusId.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
    };

    const onChangeZoneStatusId = async (obj) => {
        setZoneStatusId(obj);
        setBgZone('');
        setCombineZone('');
        if(obj && obj.id && projectTypeId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: projectTypeId.id, zoneStatusId: obj.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
        else if(obj && obj.id && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
            setCombineZonePlaceholder('กำลังโหลด...');
            const resCombineZone = await Utils.getCombineZone({langId: langId.id, zoneStatusId: obj.id});
            setCombineZonePlaceholder('เลือก..');
            if(resCombineZone && resCombineZone.data && resCombineZone.data.zones) {
                setCombineZone(resCombineZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล Combine Zone');
            }
        }
    };

    const onChangeEventDate = async (value) => {
        setEventDate(value);
        setEventReminderPlaceholder('กำลังโหลด...');
        const resEv = await Utils.getEventReminder({langId: langId.id, eventDate: value});
        setEventReminderPlaceholder('เลือก..');
        if(resEv && resEv.data && resEv.data) {
            setEventReminder(resEv.data);
        }
        else {
            toast.error('ไม่พบข้อมูล Event Reminder');
        }
    };

    const onChangeBGZoneId = async (obj) => { 
        if(document.getElementById("slug-special")) {
            document.getElementById("slug-special").value = obj.zone_slug ?? '';
        }
        setBgZoneId(obj);
    };

    const onChangeCombineZoneId = async (obj) => { 
        if(document.getElementById("slug-special")) {
            document.getElementById("slug-special").value = obj.zone_slug ?? '';
        }
        setCombineZoneId(obj);
    };

    const onChangeEventReminderId = async (obj) => { 
        if(document.getElementById("slug-special")) {
            document.getElementById("slug-special").value = obj.event_slug ?? '';
        }
        setEventReminderId(obj); 
    };

    const onChangeStaticPageId = async (obj) => {
        if(document.getElementById("slug-special")) {
            document.getElementById("slug-special").value = obj.web_page ?? '';
        }
        setStaticPageId(obj);
    };

    const onChangeAdsNamingSetNameTypeId = (obj) => {
        setAdsNamingSetNameTypeId(obj);
    };
    const onPreviewUTM = async () => {
        const param = await getParams();
        setPreview(param.params);
    };

    async function getParams() {
        let textParams = [];
        let textBoxParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            kolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(adsNamingId)) {
                                    let data = rs.data.find(e => {
                                        let id = e.id;
                                        if(id.toString().includes(kolId + ':')) {
                                            return e;
                                        }
                                    });
                                    if(data) {
                                        kolIds.push({
                                            adsNamingSourceId: parseInt(kolId),
                                            adsNamingId: parseInt(adsNamingId),
                                            name: data ? data.name : null,
                                            inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                                        });
                                    }
                                }
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                    textBoxParams = textParams;
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Special
        let slugSpecial = textBoxParams.length > 1 ? textParams[1].text:'';

        //After that
        let textParamsNew = [];
        let showOtherParam = '';
        let xLength = textBoxParams.length;

        if(textBoxParams.length > 2) {
            for(let i=2;i<xLength;i++) {
                if(textBoxParams[i].text.length > 0) {
                    textParamsNew.push({
                        adsNamingSourceId: textBoxParams[i].adsNamingSourceId,
                        adsNamingId: textBoxParams[i].id,
                        text: textBoxParams[i].text,
                        inputType: null
                    });
                }
            }
            showOtherParam = textParamsNew.map(x => x.text).join('_');
        }

        let platformName = '';
        if(platform && platformId !== null && platformId.id) {
            platformName = '_' + platform.filter(e => e.id === platformId.id)[0].name;
        }

        let params = bg + '_' + slugSpecial + '|' + showOtherParam + platformName + '|' + (adsNamingSetNameTypeId ? adsNamingSetNameTypeId.name:'') + '_[ST]';

        return {params: params, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }

    const onChangePlatformId = (platformRow) => {
        setPlatformId(platformRow);
    };

    const onChangeCustomUrl = (flag) => {
        setIsCustomUrl(flag);
        setSlugDisabled(!flag);
        if(flag) {
            setLanguageId(null);
            setProjectTypeId(null);
            setPlatformId(null);
            setSpecialFilterId(null);
            setZoneStatusId(null);
            setEventDate('');
            setBgZoneId(null);
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Ads Set Naming</div>
                    <span className="ms-1">/</span> <span className="text-muted">Special</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="urlType"
                                           id="urlType1" checked={!isCustomUrl} onChange={e => onChangeCustomUrl(false)} />
                                    <label className="form-check-label" htmlFor="urlType1">
                                        AP Special
                                    </label>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="urlType"
                                           id="urlType2" checked={isCustomUrl} onChange={e => onChangeCustomUrl(true)} />
                                    <label className="form-check-label" htmlFor="urlType2">
                                        Custom URL
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="d-block mb-1 small">{example}</div>
                        <form>
                            <div className={"row g-3 border rounded bg-light p-2 mt-0 mb-3" + (isCustomUrl ? ' d-none':'')}>
                                <div className={"col-12 mt-1" + (isCustomUrl ? ' d-none':'')}>
                                    <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={lang}
                                        onChange={(event) => onChangeLanguageId(event)}
                                        value={langId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl ? ' d-none':'')}>
                                    <label htmlFor="specialFilterId" className="form-label">Filter Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={specialFilter}
                                        onChange={(event) => onChangeFilterTypeId(event)}
                                        value={specialFilterId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                                    <label htmlFor="zoneProject" className="form-label">Zone Project <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={projectType}
                                        onChange={(event) => onChangeProjectTypeId(event)}
                                        value={projectTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || (specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) ? ' d-none':'')}>
                                    <label htmlFor="zoneStatus" className="form-label">Zone Status <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={zoneStatus}
                                        onChange={(event) => onChangeZoneStatusId(event)}
                                        value={zoneStatusId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                                    <label htmlFor="bgZone" className="form-label">BG Zone <span className="text-danger">*</span></label>
                                    <Select
                                        isDisabled={!bgZone}
                                        isClearable={true}
                                        placeholder={bgZonePlaceholder}
                                        classNamePrefix="form-select-search"
                                        options={bgZone}
                                        onChange={(event) => onChangeBGZoneId(event)}
                                        value={bgZoneId}
                                        getOptionValue={(option) => `${option.zone_slug}`}
                                        getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE ? ' d-none':'')}>
                                    <label htmlFor="combineZone" className="form-label">Combine Zone <span className="text-danger">*</span></label>
                                    <Select
                                        isDisabled={!combineZone}
                                        isClearable={true}
                                        placeholder={combineZonePlaceholder}
                                        classNamePrefix="form-select-search"
                                        options={combineZone}
                                        onChange={(event) => onChangeCombineZoneId(event)}
                                        value={combineZoneId}
                                        getOptionValue={(option) => `${option.zone_slug}`}
                                        getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                                    <label htmlFor="eventDate" className="form-label">Event Date <span className="text-danger">*</span></label>
                                    <DatePicker
                                        selected={eventDate}
                                        onChange={(date) => onChangeEventDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                                    <label htmlFor="eventReminder" className="form-label">Event Reminder <span className="text-danger">*</span></label>
                                    <Select
                                        isDisabled={!eventReminder}
                                        isClearable={true}
                                        placeholder={eventReminderPlaceholder}
                                        classNamePrefix="form-select-search"
                                        options={eventReminder}
                                        onChange={(event) => onChangeEventReminderId(event)}
                                        value={eventReminderId}
                                        getOptionValue={(option) => `${option.event_slug}`}
                                        getOptionLabel={(option) => `${option.event_title} - ${option.event_slug}`}
                                    />
                                </div>
                                <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE ? ' d-none':'')}>
                                    <label htmlFor="eventReminder" className="form-label">Static Page <span className="text-danger">*</span></label>
                                    <Select
                                        isDisabled={!staticPage}
                                        isClearable={true}
                                        placeholder={staticPagePlaceholder}
                                        classNamePrefix="form-select-search"
                                        options={staticPage}
                                        onChange={(event) => onChangeStaticPageId(event)}
                                        value={staticPageId}
                                        getOptionValue={(option) => `${option.web_page}`}
                                        getOptionLabel={(option) => `${option.web_page}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="projectTypeId" className="form-label">Platform</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={platform}
                                        onChange={(event) => onChangePlatformId(event)}
                                        value={platformId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                {
                                    adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                        adsNaming.map((row, index) => {
                                            let inputText = "sourceTypeText["+row.id+"]";
                                            let formId = '';
                                            let source = row.source;
                                            let inputType = row.inputType;

                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                formId = 'slug-special';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                        </div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} disabled={slugDisabled} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                formId = 'freeform';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}</div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} onKeyUp={e => {
                                                            if(e && e.target.value) {
                                                                e.target.value = Utils.utmSlug(e.target.value);
                                                            }
                                                        }} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                        <div className=" css-b62m3t-container">
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={kolPage.length > 0 ?kolPage.find(e => e.id === row.id).data : null}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                if(platformId !== null && row.name !== 'BG') {
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id))}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={source}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        })
                                }
                            </div>

                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={adsNamingSetNameType}
                                        onChange={(event) => onChangeAdsNamingSetNameTypeId(event)}
                                        value={adsNamingSetNameTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>

                            <div className="d-block mb-1 small">{example}</div>
                            <div className="row g-3 border rounded bg-green-light p-2 my-3">
                                <div className="col-12 mt-0">
                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onPreviewUTM} disabled={!adsNamingSetNameTypeId}>Preview</button></label>
                                    <div className="noselect-url w100 rounded">{preview}</div>
                                    <p className="mt-2 mb-0">ตัวอักษร : {preview.length}</p>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to='/adsNamingSetName'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
}